import React from "react";

import Tooltip from "material-ui/Tooltip";
import InfoWhite from "assets/images/info-white.png";
import InfoGreen from "assets/images/info-green.png";

const CTooltips = props => {
  return (
    <div
      style={Object.assign({}, props.style, {
        display: "inline-block",
        marginBottom: -4
      })}
    >
      <div
        role={props.button ? "button" : ""}
        className={props.button ? props.classes.button : ""}
        onClick={props.disabled ? null : props.onClick}
        onKeyDown={props.disabled ? null : props.onClick}
      >
        {props.children}
        {props.text && <span style={{ marginRight: 5 }}>{props.text}</span>}
        <Tooltip
          {...props}
          classes={props.classes && { tooltip: props.classes.tooltip }}
          style={{ height: 20 }}
        >
          <img
            src={props.light ? InfoWhite : InfoGreen}
            style={{ width: 20, height: 20, verticalAlign: "sub" }}
            alt="apple-logo"
          />
        </Tooltip>
      </div>
    </div>
  );
};

export default CTooltips;



// WEBPACK FOOTER //
// ./src/uis/CTooltips.jsx